module.exports = function() {
	throw new Error("define cannot be used indirect");
};



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-define.js
// module id = LGuY
// module chunks = 0 1 2 3 4 5 6 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30